<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t('gradeControleur.gradeControleurs') }}</h2>
    </div>
    <el-row :gutter="40" class="panel-group">
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <h1>C</h1>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">
              Total Controleurs
            </div>
            <count-to :start-val="0" :end-val="list.length" :duration="2600" class="card-panel-num" />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-card v-if="checkRole(['admin'])" class="box-card filter-card just-for-admin">
      <div slot="header" class="clearfix">
        <span>{{ $t('general.filter') }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="initSearch">{{ $t('general.init') }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio v-model="activeList" label="desactives" border @change="getSubGradeControleursList('indexdesactive')">{{ $t('general.F_desactives') }}</el-radio>
        <el-radio v-model="activeList" label="disponibles" border @change="handleFilterGradeControleurs">{{ $t('general.disponibles') }}</el-radio>
        <el-radio v-model="activeList" label="corbeille" class="danger-radio" border @change="getSubGradeControleursList('indexinvisible')">{{ $t('general.corbeille') }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input v-model="query.keyword" :placeholder="$t('general.keyword')" class="wd-200 mr-15 filter-item" @keyup.enter.native="handleFilterGradeControleurs" />
        <el-button v-waves class="mr-15 filter-item" type="primary" icon="el-icon-search" @click="handleFilterGradeControleurs">
          {{ $t('general.search') }}
        </el-button>
        <el-button v-waves :loading="downloading" class="filter-item" type="primary" icon="el-icon-download" @click="handleDownload">
          {{ $t('general.export') }}
        </el-button>
        <el-button v-if="checkPermission(['creer gradeControleur'])" class="mr-15 filter-item" type="primary" icon="el-icon-plus" @click="handlecreateGradeControleur">
          {{ $t('general.add') }}
        </el-button>
        <el-button v-if="checkPermission(['creer gradeControleur'])" class="mr-15 filter-item" type="primary" icon="el-icon-plus" @click="drawer=true">
          Importer
        </el-button>
      </div>
      <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">
        <!-- el-table-column align="center" label="Code" min-width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column -->

        <el-table-column align="center" :label="$t('general.nom')" min-width="200px">
          <template slot-scope="scope">
            <span>{{ scope.row.nom }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('general.description')" min-width="300px">
          <template slot-scope="scope">
            <span>{{ scope.row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="checkPermission(['activer gradeControleur'])" align="center" :label="$t('general.status')" width="100">
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              @change="setGradeControleurStatus(scope.row.id,'active')"
            />
          </template>
        </el-table-column>

        <el-table-column v-if="checkRole(['admin']) && (activeList=='corbeille' || query.keyword)" align="center" :label="$t('general.restaurer')" width="100">
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setGradeControleurStatus(scope.row.id,'visible')"
            />
          </template>
        </el-table-column>

        <el-table-column v-if="checkPermission(['modifier gradeControleur','visible gradeControleur','supprimer gradeControleur'])" align="center" :label="1==1 ? $t('general.actions') : $t('general.suppressionDefinitive')" width="200">
          <template slot-scope="scope">
            <el-button v-if="scope.row.is_visible && checkPermission(['modifier gradeControleur'])" type="primary" size="small" icon="el-icon-edit" style="margin-right:10px;" @click="handleEditGradeControleur(scope.row.id);" />
            <el-button v-if="checkPermission(['visible gradeControleur','supprimer gradeControleur'])" slot="reference" type="danger" size="small" icon="el-icon-delete" style="margin-right:10px;" @click="handleDeleteGradeControleur(scope.row.id, scope.row.is_visible, scope.row.nom);" />
            <el-button type="info" size="small" icon="el-icon-view" @click="showDetailsPage(scope.row.id)" />
          </template>
        </el-table-column>
      </el-table>

      <pagination v-if="total > query.limit" :total="total" :page.sync="query.page" :limit.sync="query.limit" @pagination="getGradeControleursList" />

      <!-- ======= REGION USER DIALOG ======= -->
      <el-dialog
        :title="editing ? $t('gradeControleur.edit') + ' ' + currentGradeControleur.nom : $t('gradeControleur.AddGradeControleur')"
        :visible.sync="dialogCreateGradeControleur"
        :before-close="handleCloseCampagneagricoleCreateDraw"
        :loading="gradeControleurCreating"
        width="30%"
      >
        <div class="content-inputs">
          <el-form ref="gradeControleurForm" :rules="rules" :model="currentGradeControleur" label-position="left">
            <el-form-item :label="$t('gradeControleur.nom')" prop="nom">
              <el-input v-model="currentGradeControleur.nom" />
            </el-form-item>
            <el-form-item :label="$t('general.description')" prop="description">
              <el-input v-model="currentGradeControleur.description" type="textarea" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:right;">
            <el-button plain type="danger" @click="dialogCreateGradeControleur=false">
              {{ $t('permission.cancel') }}
            </el-button>
            <el-button type="primary" :loading="gradeControleurCreating" @click="editing ? updateGradeControleur() : createGradeControleur()">
              {{ gradeControleurCreating ? $t('general.saving') : $t('general.save') }}
            </el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog
        title="Importation"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        width="60%"
      >
        <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
        <el-table :data="tableData" border highlight-current-row style="width: 100%;margin-top:20px;">
          <el-table-column v-for="item of tableHeader" :key="item" :prop="item" :label="item" />
        </el-table>
        <el-button type="success" :disabled="!tableData.length>0" @click="bulkInsert">Insérer</el-button>
      </el-dialog>

      <!-- ======= REGION USER DIALOG ======= -->

    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
import CountTo from 'vue-count-to';
const gradeControleurResource = new Resource('grade_controleurs');
const bulkGradeControleurResource = new Resource('grade_controleurs_import');
import UploadExcelComponent from '@/components/UploadExcel/index.vue';
export default {
  name: 'GradeControleursList',
  // components: {  },
  components: { UploadExcelComponent, Pagination, CountTo },
  directives: { waves, permission, role },
  data() {
    return {
      tableData: [],
      tableHeader: [],
      drawer: false,
      list: null,
      total: 0,
      loading: true,
      downloading: false,
      activeList: 'disponibles',
      gradeControleurCreating: false,
      editing: false,
      currentGradeControleur: {},
      query: {
        page: 1,
        limit: 100,
        keyword: '',
      },
      dialogCreateGradeControleur: false,
      currentGradeControleurId: 0,
      rules: {
        nom: [{ required: true, message: this.$t('gradeControleur.NomRequired'), trigger: 'blur' }],
      },
      fileList: [],
    };
  },
  computed: {

  },
  created() {
    this.resetNewGradeControleur();
    this.getGradeControleursList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array){
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseCampagneagricoleCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    bulkInsert(){
      console.log('LES ENTETES : ', this.tableHeader);
      var validHeaders = this.tableHeader.length === 2 && this.tableHeader[0] === 'nom' && this.tableHeader[1] === 'description';
      if (validHeaders) {
        console.log('DATA : ', this.tableData);
        const data = { 'grades': this.tableData };
        bulkGradeControleurResource
          .store(data)
          .then(async(response) => {
            this.$message({
              message: this.$t('gradeControleur.NewGradeControleur') + this.$t('gradeControleur.iscreatedSuccessfully'),
              type: 'success',
              duration: 5 * 1000,
            });
            // this.currentProduitId = response.data.id;
            this.resetNewGradeControleur();
            this.dialogCreateGradeControleur = false;
            this.handleFilterGradeControleurs();
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.gradeControleurCreating = false;
            this.drawer = false;
            this.tableHeader = [];
            this.tableData = [];
          });
        // for (let index = 0; index < this.tableData.length; index++) {
        //   const element = this.tableData[index];
        //   console.log('A INSERER : ', element);
        //   if (element.nom !== '') {
        //     gradeControleurResource
        //       .store(element)
        //       .then(async(response) => {
        //         console.log('index ', index, response.data);
        //       })
        //       .catch(error => {
        //         console.log(error);
        //       })
        //       .finally(() => {
        //         this.drawer = false;
        //         this.tableHeader = [];
        //         this.tableData = [];
        //       });
        //   }
        // }
        console.log('ENTETES VALIDE');
      } else {
        this.$message({
          message: 'DONNEES NON CONFORMES',
          type: 'info',
          duration: 5 * 1000,
        });
      }
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning',
      });
      return false;
    },
    handleSuccess({ results, header }) {
      this.tableData = results;
      this.tableHeader = header;
    },
    cancelgradeControleurForm() {
      this.$refs.CampagneagricoleCreationDrawer.closeDrawer();
    },
    async setGradeControleurStatus(id, type){
      const data = await gradeControleurResource.get('toogle_' + type + '/' + id);
      if (data.success){
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    initSearch(){
      this.handleFilterGradeControleurs();
    },
    showDetailsPage(id){
      this.$router.push({ path: '/grade/' + id });
    },
    async getGradeControleursList() {
      this.loading = true;
      const { data, meta } = await gradeControleurResource.list(this.query);
      this.list = data.reverse();
      this.total = meta.total;
      console.log('===== EDI');
      console.log(data);
      console.log('===== EVO');
      this.loading = false;
    },
    async getSubGradeControleursList(subUrl) {
      this.loading = true;
      const { data } = await gradeControleurResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterGradeControleurs() {
      this.query.page = 1;
      this.getGradeControleursList();
    },
    handlecreateGradeControleur() {
      this.editing = false;
      this.resetNewGradeControleur();
      this.dialogCreateGradeControleur = true;
      this.$nextTick(() => {
        this.$refs['gradeControleurForm'].clearValidate();
      });
    },
    handleEditGradeControleur(id){
      this.editing = true;
      this.resetNewGradeControleur();
      this.currentGradeControleur = this.list.find(abonne => abonne.id === id);
      this.dialogCreateGradeControleur = true;
      this.$nextTick(() => {
        this.$refs['gradeControleurForm'].clearValidate();
      });
    },
    handleDeleteGradeControleur(id, visible, nom) {
      console.log('id : ' + id + 'nom : ' + nom);
      this.$confirm(this.$t('gradeControleur.deleteWarn') + ' ' + nom + '. ' + this.$t('general.deleteContinue'), 'Warning', {
        confirmButtonText: 'Oui',
        cancelButtonText: this.$t('general.cancel'),
        type: 'warning',
      }).then(() => {
        console.log('result : ');
        if (!visible && (checkRole(['admin']) || checkPermission(['supprimer gradeControleur']))) {
          console.log('result 2 : ');
          this.$swal({
            title: this.$t('general.SureQuestion'),
            text: this.$t('general.irrversibleMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('general.ouiSupprimer'),
          }).then((result) => {
            if (result.isConfirmed) {
              gradeControleurResource.destroy(id).then(response => {
                this.$message({
                  type: 'success',
                  message: this.$t('gradeControleur.suppressionEffectue'),
                });
                this.initSearch();
              }).catch(error => {
                console.log(error);
              });
            }
          });
        } else {
          this.setGradeControleurStatus(id, 'visible');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('general.suppressionAnnule'),
        });
      });
    },
    createGradeControleur() {
      this.$refs['gradeControleurForm'].validate((valid) => {
        if (valid) {
          this.gradeControleurCreating = true;
          gradeControleurResource
            .store(this.currentGradeControleur)
            .then(async(response) => {
              this.$message({
                message: this.$t('gradeControleur.NewGradeControleur') + ' ' + this.currentGradeControleur.nom + ' ' + this.$t('gradeControleur.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentGradeControleurId = response.data.id;
              this.resetNewGradeControleur();
              this.dialogCreateGradeControleur = false;
              this.handleFilterGradeControleurs();
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.gradeControleurCreating = false;
            });
        } else {
          console.log('Erreur !!');
          return false;
        }
      });
    },
    updateGradeControleur() {
      this.$refs['gradeControleurForm'].validate((valid) => {
        if (valid) {
          this.gradeControleurCreating = true;
          gradeControleurResource.update(this.currentGradeControleur.id, this.currentGradeControleur).then(response => {
            this.resetNewGradeControleur();
            this.handleFilterGradeControleurs();
            this.$message({
              message: this.$t('gradeControleur.isupdatedSuccessfully'),
              type: 'success',
              duration: 5 * 1000,
            });
            this.dialogCreateGradeControleur = false;
            this.editing = false;
          })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.gradeControleurCreating = false;
            });
        } else {
          console.log('Erreur !!');
          return false;
        }
      });
    },
    resetNewGradeControleur() {
      this.currentGradeControleur = {
        nom: '',
        description: '',
      };
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['ID', this.$t('gradeControleur.nom'), this.$t('general.description')];
        const filterVal = ['id', 'nom', 'description'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Liste des gradeControleurs SCIAGRI_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    onChange(file, fileList){
      var a = this.fileList;
      a.push({ name: file.name, url: file.url });
      // console.log('onChange begin');
      this.fileList = a;
      // console.log(this.fileList);
      // console.log('onChange end');
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
